import { OrderedAsyncEnumerable } from "../OrderedAsyncEnumerable.js";
export const order = (source, comparer) => {
    return OrderedAsyncEnumerable.generate(source, (x) => x, true, comparer);
};
